// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles-module--wrap--1d5kU","colored":"styles-module--colored--37VAu","card":"styles-module--card--2ziFy","primary_list":"styles-module--primary_list--2IKVd"};